<app-user-form
  [user]="null"
  action="{{ 'new' | translate }}"
  [preselectedOfficeId]="officeId"
  (close)="closeForm($event)">
</app-user-form>
